const width = 40;
const height = 35.42;
const fixCentering = `translate(${-width / 2},${-height / 2})`;

export const Heart = ({ color }) => (
  <g transform={fixCentering}>
    <path
      d="M35.5881 8.7906V4.4224H31.2095V0H26.7453V4.44328H22.302V8.84278H17.7085V4.44328H13.2777V0H8.80107V4.4224H4.41199V8.7906H0V17.6646H4.4537V22.1183H8.80102L8.88655 22.1203V26.5427H13.3298V30.9756H17.7731V35.4189L22.2373 35.4168V30.9735H26.6806V26.5407H31.0926V22.1203H35.5671V17.6666H40V8.79055L35.5881 8.7906ZM26.6287 26.4451V26.4659V26.4451ZM13.3511 26.4659V26.4451V26.4659Z"
      fill={color}
    />
  </g>
);
